module.exports = __webpack_public_path__ + "img/create.ef4877bf.svg";